class TLRemoteSyncError extends Error {
  constructor(reason) {
    super(`sync error: ${reason}`);
    this.reason = reason;
  }
  name = "RemoteSyncError";
}
export {
  TLRemoteSyncError
};
//# sourceMappingURL=TLRemoteSyncError.mjs.map
